import { ApiProperty } from "@nestjs/swagger";

export class BrandsInfo {
    @ApiProperty()

    brandId: number;
    @ApiProperty()
    brandName: string;

    @ApiProperty()
    masterBrandId: number;
    
    @ApiProperty()
    endCustomerId: number;
    
    @ApiProperty()

    createdUser: string;


    constructor(brandId: number, brandName: string,masterBrandId: number, createdUser: string,endCustomerId: number) {
        this.brandId = brandId;
        this.brandName = brandName;
        this.masterBrandId =masterBrandId;
        this.endCustomerId = endCustomerId;
        this.createdUser = createdUser;
    }
}


